import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const RepairLogEntry = ({ logEntry, user, currentRepairLog }) => {
  return (
    <tr>
      <td>
        <Link
          to={
            '/repair-log/' +
            currentRepairLog.id +
            '/repair-log-entries/' +
            logEntry.id
          }
        >
          {Number.parseFloat(logEntry.hoursTaken).toFixed(2)}
        </Link>
      </td>
      <td>{logEntry.location}</td>
      <td>{logEntry.description}</td>
      <td>{user ? user.initials : 'N/A'}</td>
    </tr>
  );
};

RepairLogEntry.propTypes = {
  logEntry: PropTypes.object.isRequired,
};

export default RepairLogEntry;



// WEBPACK FOOTER //
// ./src/components/repair-log/RepairLogEntry.js